import React from "react";
import {Button, FormCheck, FormControl, InputGroup, OverlayTrigger, Popover} from "react-bootstrap";

export class SuperbillDxInput extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value) {
            console.log(`value changed from ${prevProps.value} to ${this.props.value}`);
        }
    }

    dxChanged = (e, fullCode) => {
        let selected = this.props.value ? this.props.value.split(', ') : [];
        if (e.target.checked) {
            selected.push(fullCode);
        } else {
            selected.splice(selected.findIndex(i => i == fullCode), 1);
        }
        let csv = selected.join(', ');
        this.props.onDxChanged(csv);
    }

    render() {
        let selected = this.props.value ? this.props.value.split(', ') : [];

        return <InputGroup className={this.props.className}>
            <FormControl
                placeholder="Supporting DXs"
                aria-label="Supporting DXs"
                aria-describedby="basic-addon2"
                disabled
                value={this.props.value || ""}
                size={"sm"}/>
            {!this.props.disabled && <OverlayTrigger
                trigger={"click"}
                rootClose
                placement={"top"}
                overlay={
                    <Popover id={`popover-dx`} style={{maxWidth: "400px"}}>
                        <Popover.Title>Which diagnoses support this order?</Popover.Title>
                        <Popover.Content style={{whiteSpace: "normal"}}>
                            {
                                (this.props.allIcds || []).filter(i => i.fullCode != null)
                                    .map(icd => <div key={"icd" + icd.fullCode}>
                                        <FormCheck label={`${icd.fullCode || ''} ${icd.description}`}
                                                   checked={selected.includes(icd.fullCode)}
                                                   onChange={(e) => this.dxChanged(e, icd.fullCode)}/>
                                    </div>)
                            }
                        </Popover.Content>
                    </Popover>
                }
            >
                <Button as={InputGroup.Append} size={"sm"} variant={"secondary"} disabled={this.props.disabled}>Select
                    DX</Button>
            </OverlayTrigger>}
        </InputGroup>
    }
}